import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "tabs",
  data: function data() {
    return {
      active: ""
    };
  },
  watch: {
    dataChart: {
      handler: function handler(val) {
        if (val.length !== 0) {
          this.handleClick(val[0], 0, true);
        }
      },
      immediate: true
    }
  },
  computed: {
    isSelect: function isSelect() {
      return this.type === "select";
    },
    type: function type() {
      return this.option.type;
    },
    paramName: function paramName() {
      return this.option.paramName;
    },
    iconSize: function iconSize() {
      return this.option.iconSize || 20;
    },
    styleSelectName: function styleSelectName() {
      return Object.assign({
        fontSize: this.setPx(this.option.fontSize || 30)
      }, this.styleSizeName);
    },
    styleIconName: function styleIconName() {
      return Object.assign({
        marginRight: this.setPx(this.option.iconSplit),
        width: this.setPx(this.option.iconSize),
        height: this.setPx(this.option.iconSize)
      });
    },
    styleName: function styleName() {
      var _this = this;

      return Object.assign(function () {
        if (_this.option.backgroundImage) {
          return {
            backgroundImage: "url(".concat(_this.option.backgroundImage, ")"),
            backgroundSize: "100% 100%"
          };
        }

        return {};
      }(), {
        borderColor: this.option.borderColor || "#fff",
        borderStyle: "solid",
        borderWidth: this.setPx(this.option.borderWidth || 0),
        margin: "0 ".concat(this.setPx(this.option.split)),
        backgroundColor: this.option.backgroundColor,
        fontSize: this.setPx(this.option.fontSize || 30),
        color: this.option.color
      });
    }
  },
  methods: {
    styleIconBgName: function styleIconBgName(item) {
      if (item.icon) {
        return {
          backgroundImage: "url(".concat(item.icon, ")"),
          backgroundSize: "100% 100%"
        };
      }
    },
    styleIconActiveName: function styleIconActiveName(item) {
      if (this.active == item.value && item.empIcon) {
        return {
          backgroundImage: "url(".concat(item.empIcon, ")"),
          backgroundSize: "100% 100%"
        };
      }
    },
    styleActiveName: function styleActiveName(item) {
      var _this2 = this;

      if (this.active == item.value) {
        return Object.assign(function () {
          if (_this2.option.empBackgroundImage) {
            return {
              backgroundImage: "url(".concat(_this2.option.empBackgroundImage, ")"),
              backgroundSize: "100% 100%"
            };
          }

          return {};
        }(), {
          borderColor: this.option.empBorderColor || "#fff",
          borderStyle: "solid",
          borderWidth: this.setPx(this.option.empBorderWidth || 0),
          color: this.option.empColor
        });
      }
    },
    handleClick: function handleClick(item, index) {
      var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      this.active = item.value;
      this.updateClick(item);
      this.clickFormatter && this.clickFormatter({
        type: index,
        item: item,
        value: item.value,
        data: this.dataChart
      }, this.getItemRefs());
      if (item.href && !target) window.open(item.href, item.target);
    }
  },
  props: {
    option: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});